import React from 'react';

const WithUsSection = ({ withUsData }) => {
    return (
        <section className="withus-section">
            <div className="container">
                <div className="inner-content">
                    <h5>{withUsData.subtitle}</h5>
                    <h2>{withUsData.heading}</h2>
                    <p><b>{withUsData.intro}<br></br>{withUsData.introtwo}</b></p>
                    <p>{withUsData.registrationTitle}</p>
                    <p>{withUsData.membershipTitle}</p>
                    <div className="p-data">
                        {withUsData.memberships.map((item, index) => (
                            <p key={index}>{item},</p>
                        ))}
                    </div>
                    {withUsData.additionalParagraphs.map((text, index) => (
                        <div className="p-data" key={index}>
                            <p>{text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WithUsSection;
